import { Action } from '../../common/actions/core/action';

export class OpenPreInfoFormAction implements Action {
  constructor(public onApprove: () => void, public offerId?: string, public paymentType?: string) {}
}



// WEBPACK FOOTER //
// src/app/buy/pre-info-form-dialog/pre-info-form-dialog.action.ts